
// 指定IDの要素へスクロール
export function scrollToAnchor(targetId, headerSelector = '.l-header') {
  const targetElement = document.getElementById(targetId);
  const header = document.querySelector(headerSelector);
  const headerHeight = header ? header.offsetHeight : 0;

  if (targetElement) {
    const targetTop = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  }
}